const initHTMLElement = () => {
  // @ts-ignore
  // 扩展 HTMLElement 原型
  HTMLElement.prototype.measureInWindow = function () {
    // 使用 getBoundingClientRect 获取元素的尺寸和位置
    const rect = this.getBoundingClientRect();

    // 返回包含 top, left, width, height 的对象
    return {
      y: rect.top + window.scrollY,
      x: rect.left + window.scrollX,
      width: rect.width,
      height: rect.height,
    };
  };
};

export default initHTMLElement;
